import { render, staticRenderFns } from "./bidui-dialog.vue?vue&type=template&id=379e7ffa&scoped=true"
import script from "./bidui-dialog.vue?vue&type=script&lang=ts"
export * from "./bidui-dialog.vue?vue&type=script&lang=ts"
import style0 from "./bidui-dialog.vue?vue&type=style&index=0&id=379e7ffa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379e7ffa",
  null
  
)

export default component.exports